export default {
    name: 'TarefasMixin',
    data() {
        return {
            isSuporte: false
        }
    },
    inject: {
    },
    beforeMount() {
        this.testRoute()
    },
    mounted() {
        document.body.classList.add('suporte-module-body')
    },
    destroyed() {
        document.body.classList.remove('suporte-module-body')
    },
    beforeDestroy() {
    },
    methods: {
        testRoute() {
            if (this.$route.query.suporte && this.$route.query.suporte == '1') {
                this.isSuporte = true
            } else {
                this.isSuporte = false
            }
        }
    }
}
